import {
  ThirdwebProvider,
  metamaskWallet,
  coinbaseWallet,
  walletConnect,
  rainbowWallet,
} from "@thirdweb-dev/react";
import { Flare, SongbirdCanaryNetwork } from "@thirdweb-dev/chains";
import CustomCursor from "./utils/CustomCursor";
import GlobalStyles from "./styles/GlobalStyles";
import { dark } from "./styles/Themes";
import { ThemeProvider } from "styled-components";
import VaultDapp from "./components/sections/VaultDapp";
import { useState, useEffect, lazy, Suspense } from "react";
import Loading from "./components/Loading";
import TokenFaucet from "./components/sections/TokenFaucet";
import VideoHero from "./components/sections/VideoHero";
// Below Imports using React.lazy and Suspence
const Navigation = lazy(() => import("./components/Navigation"));
const Home = lazy(() => import("./components/sections/Home"));
const About = lazy(() => import("./components/sections/About"));
const Roadmap = lazy(() => import("./components/sections/Roadmap"));
const Team = lazy(() => import("./components/sections/Team"));
const Showcase = lazy(() => import("./components/sections/Showcase"));
const Faq = lazy(() => import("./components/sections/Faq"));
const Footer = lazy(() => import("./components/Footer"));
const ScrollToTop = lazy(() => import("./components/ScrollToTop"));
const Divider = lazy(() => import("./components/sections/Divider"));
// const VideoHero = lazy(() => import("./components/sections/VideoHero"));



function App() {

  const [scrollPosition, setScrollPosition] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrollPosition(window.scrollY);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <main>
    <ThirdwebProvider
  activeChain={SongbirdCanaryNetwork}
  supportChains={[
    
    Flare
    ]}
      clientId="07d2e88c135e09c8e36531863f24cb94"
      supportedWallets={[
        metamaskWallet({ recommended: true }),
        coinbaseWallet(),
        walletConnect(),
        rainbowWallet(),
        
      ]}
      
    >
      <GlobalStyles />
      <ThemeProvider theme={dark}>
      
        <Suspense fallback={<Loading />}>
        <CustomCursor />
          <Navigation />
          <Home />
          <About />
          <VideoHero />

          <Roadmap />
          <Showcase />
          <Divider />
          <VaultDapp />
          <TokenFaucet />

          <Divider />

          <Team />
       
          <Faq />
          <Footer />
          <ScrollToTop scrollPosition={scrollPosition}/>
          <ScrollToTop />{" "}
        </Suspense>
      </ThemeProvider>
      </ThirdwebProvider>

    </main>
  );
}

export default App;
